import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AlarmClock,
  BadgeCheck,
  Building2,
  CalendarDays,
  CircleX,
  ContactRound,
  GraduationCap,
  Wrench,
} from "lucide-react";
import api from "../../lib/api";
import { Loading, PageHeader } from "../../components/shared";

const cards = [
  ["total", "Total Leads", ContactRound, ""],
  ["new", "New Leads", ContactRound, "status=NEW"],
  ["followups_due_today", "Follow-ups Due Today", AlarmClock, "followup=today"],
  ["overdue_followups", "Overdue Follow-ups", AlarmClock, "followup=overdue"],
  ["meetings_scheduled", "Meetings Scheduled", CalendarDays, "meeting=scheduled"],
  ["society", "Society Leads", Building2, "lead_type=SOCIETY"],
  ["vendor", "Vendor Leads", Wrench, "lead_type=VENDOR"],
  ["expert", "Expert Leads", GraduationCap, "lead_type=EXPERT"],
  ["applications", "Applications", BadgeCheck, "has_application=yes"],
  ["converted", "Converted", BadgeCheck, "conversion=converted"],
  ["lost", "Lost / Closed", CircleX, "conversion=lost"],
];

export default function AdminCrmDashboard() {
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/admin/crm/dashboard").then((response) => setSummary(response.data));
  }, []);

  if (!summary) return <Loading />;

  return (
    <div data-testid="crm-dashboard-page">
      <PageHeader
        title="CRM Dashboard"
        subtitle="Track every Society, Vendor, and Expert opportunity from first contact to conversion."
      />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {cards.map(([key, label, Icon, filter]) => (
          <button
            className="bg-card border rounded-xl p-5 text-left shadow-[0_8px_32px_rgba(0,0,0,0.04)] hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow]"
            data-testid={`crm-dashboard-card-${key}`}
            key={key}
            onClick={() => navigate(`/admin/leads${filter ? `?${filter}` : ""}`)}
          >
            <span className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
              <Icon className="w-5 h-5" />
            </span>
            <strong className="font-display block text-2xl mt-4" data-testid={`crm-dashboard-value-${key}`}>
              {summary[key] ?? 0}
            </strong>
            <span className="text-sm text-muted-foreground">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}